import { useContext, useMemo } from 'react'
import { AppContext, AppContextType, AppDeveloperOptions } from '../../AppContext'
import { LOG_LEVEL_DEFAULT } from '../../services/Logger'
import useAppContextRef from '../../services/useAppContextRef'

export default function useDeveloperOptionsActions() {
    const { dispatch: appDispatch } = useContext(AppContext) as AppContextType
    const { appStateRef } = useAppContextRef()

    return useMemo(() => {
        const getDeveloperOptions = () => {
            return appStateRef.current.appSettings.developerOptions || {}
        }

        const updateDeveloperOptions = (deltaObj: Partial<AppDeveloperOptions>) => {
            appDispatch({
                type: 'update_app_settings',
                value: {
                    developerOptions: {
                        ...getDeveloperOptions(),
                        ...deltaObj,
                    },
                },
            })
        }

        const setOptionsFromEnv = (env: { [key: string]: any }) => {
            updateDeveloperOptions({
                enableAuditLogging: !!env.ENABLE_AUDIT_LOGGING,
                logLevel: env.LOG_LEVEL?.toString() ?? LOG_LEVEL_DEFAULT.toString(),
            })
        }

        const setDeveloperMode = (value: boolean) => {
            appDispatch({
                type: 'update_app_state',
                value: { isInDevMode: value },
            })
        }

        return {
            getDeveloperOptions,
            updateDeveloperOptions,
            setOptionsFromEnv,
            setDeveloperMode,
        }
    }, [])
}
